import {
  createFileRoute,
  Outlet,
} from '@tanstack/react-router';
import React, {
  useEffect,
  useState,
} from 'react';
import {
  Provider,
} from 'react-redux';

import {
  ErrorBoundary,
} from '#components/errors/ErrorBoundary';
// import store from '#src/state/store';

export const Route = createFileRoute('/_app')({
  component: AppLayoutComponent,
});

function AppLayoutComponent() {
  return (
    <ErrorBoundary
      fallback="Error loading state providers"
    >
      <ErrorBoundary
        fallback="Error loading application"
      >
        <Outlet />
      </ErrorBoundary>
    </ErrorBoundary>
  );
}
